import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { StreamID } from '@ceramicnetwork/streamid';
export function typeStreamID(streamId) {
  return typeof streamId === 'string' ? StreamID.fromString(streamId) : streamId;
}
export function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
export function delay(_x) {
  return _delay.apply(this, arguments);
}
function _delay() {
  _delay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(mills) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Promise(function (resolve) {
            return setTimeout(function () {
              return resolve();
            }, mills);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _delay.apply(this, arguments);
}